var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Base',{attrs:{"show-search":false,"minimal-topbar":true,"show-back-button":true,"title":"Heimdall - Groups"},scopedSlots:_vm._u([{key:"main-content",fn:function(){return [_c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',[_c('GroupManagement',{attrs:{"admin-panel":false}})],1)],1)],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }